module.exports = __webpack_public_path__ + "static/media/buzon-rojo-denuncia.4193a49d.png";